import React from "react";
import { Edit, SimpleForm, TextInput, DateInput, NumberInput } from "react-admin";

const AppReleasesEdit = () => (
  <Edit title="Editar versão do app">
    <SimpleForm>
      <TextInput source="version" label="Versão" disabled />
      <NumberInput source="build" label="Build" />
      <DateInput source="releaseDate" label="Lançamento" />
      <TextInput source="notesPt" label="Notas (PT)" multiline fullWidth minRows={8} />
    </SimpleForm>
  </Edit>
);

export default AppReleasesEdit;
